import { lazy } from 'react';
import type { AppModule } from '@/app/module-registry';
import { RequireAccount } from '@/core/auth/permissions';

const PlansPage = lazy(() => import('./PlansPage'));
const CheckoutPage = lazy(() => import('./CheckoutPage'));

/**
 * A vitrine de planos e a cobrança são DOIS módulos, e a separação tem
 * motivo: mostrar planos é marketing e vale desde o primeiro dia; cobrar
 * depende do gateway homologado, que é Fase 2 (Cap. 37).
 *
 * Antes os dois estavam sob a mesma flag, e desligar a cobrança derrubava
 * junto a página de planos — que é a peça de venda do portal.
 *
 * A vitrine é aberta; a cobrança exige conta. A API amarra cada cobrança ao
 * dono do token, então sem identidade o formulário só levaria a pessoa até um
 * 401 depois de digitar tudo.
 */
export const plansModule: AppModule = {
  key: 'plans',
  order: 30,
  routes: [{ path: 'planos', element: <PlansPage /> }],
};

export const checkoutModule: AppModule = {
  key: 'checkout',
  order: 31,
  requiredFeature: 'checkout',
  routes: [
    {
      path: 'checkout',
      element: (
        <RequireAccount>
          <CheckoutPage />
        </RequireAccount>
      ),
    },
  ],
};
